import { all, takeEvery, put, fork, call } from "redux-saga/effects";
import { notification as notifications } from "antd";
import actions from "./actions";
import { login, updateUserDataRequest } from "../../services/authService";

export function* loginRequest(payload) {
  try {
    const response = yield call(login, payload);

    if (response[0] === 200) {
      yield put({
        type: actions.LOGIN_SUCCESS,
        token: response[1]["jwtToken"],
      });

      localStorage.setItem("id_token", response[1]["jwtToken"]);
      localStorage.setItem("role", response[1]["role"]);
      localStorage.setItem(
        "portalOrganizationIds",
        response[1]["portalOrganizationIds"]
      );
      localStorage.setItem(
        "fullName",
        response[1]["firstName"] + " " + response[1]["lastName"]
      );

      if (response[1]["portalOrganizationIds"].length === 0) {
        window.location = "/waiting";
      } else {
        window.location = "/orders";
      }
    } else if (response[0] === 429) {
      notifications["error"]({
        message: "Грешка",
        description: "Прекалено много заявки. Моля, опитайте по-късно.",
      });
    } else {
      if (response[0] === 404) {
        notifications["error"]({
          message: "Грешка",
          description: "Грешно потребителско име или парола!",
        });
      } else {
        let msg = "";
        if (response[1].errors !== undefined) {
          const errorMessages = [];
          for (let error in response[1].errors) {
            response[1].errors[error].forEach((errorMessage) => {
              errorMessages.push(errorMessage);
            });
          }
          msg += errorMessages.join(" ");
        }
        if (response[1]["title"] !== undefined) {
          msg += response[1]["title"];
        }
        notifications["error"]({
          message: "Грешка",
          description: msg,
        });
      }
    }
  } catch (error) {
    notifications["error"]({
      message: "Грешка",
    });
  }
}

export function* loginSuccess() {
  yield takeEvery(actions.LOGIN_SUCCESS, function* (payload) {
    yield localStorage.setItem("id_token", payload.token);
  });
}

export function* loginError() {
  yield takeEvery(actions.LOGIN_ERROR, function* () {});
}

export function* checkAuthorization() {
  const token = localStorage.getItem("id_token");
  const oldRole = localStorage.getItem("role");
  const oldOrganizationIds = localStorage.getItem("portalOrganizationIds");
  if (token) {
    const response = yield call(updateUserDataRequest, token);
    if (response[0] === 200) {
      localStorage.setItem("id_token", response[1]["jwtToken"]);
      localStorage.setItem("role", response[1]["role"]);
      localStorage.setItem(
        "portalOrganizationIds",
        response[1]["portalOrganizationIds"]
      );
      localStorage.setItem(
        "fullName",
        response[1]["firstName"] + " " + response[1]["lastName"]
      );
    }

    if (
      response[0] === 200 &&
      (oldOrganizationIds !== response[1]["portalOrganizationIds"] ||
        oldRole !== response[1]["role"])
    ) {
      if (response[1]["portalOrganizationIds"].length === 0) {
        window.location = "/waiting";
      } else {
        window.location = "orders";
      }

      localStorage.setItem("id_token", response[1]["jwtToken"]);
      localStorage.setItem("role", response[1]["role"]);
      localStorage.setItem(
        "portalOrganizationIds",
        response[1]["portalOrganizationIds"]
      );
      localStorage.setItem(
        "fullName",
        response[1]["firstName"] + " " + response[1]["lastName"]
      );
    }
  }
}

function handleLogout() {
  localStorage.clear();
  window.location = "/signin";
}

export default function* rootSaga() {
  yield all([
    yield takeEvery(actions.LOGIN_REQUEST, loginRequest),
    yield takeEvery(actions.CHECK_AUTHORIZATION, checkAuthorization),
    yield takeEvery(actions.LOGOUT, handleLogout),
    fork(loginSuccess),
    fork(loginError),
  ]);
}
